export enum LoginProvider {
  Sso = 'SSO',
  Standard = 'Standard',
}
